import { type YMALSegmentKeys } from '../types';

import { type ProductBySlugExtendedResponse } from '@/modules/product/aliases';

export function getSegmentTitleArgs({
  productExtended,
  segmentName,
}: {
  segmentName: YMALSegmentKeys;
  productExtended?: ProductBySlugExtendedResponse;
}) {
  const { brand, group_name, product_type_name } =
    productExtended?.attributes || {};

  switch (segmentName) {
    case 'brand':
      if (brand?.name === 'Other') {
        return ['DiscoverSomethingDifferent'] as const;
      }
      return ['ItemsFromBrand', { brand: brand?.name || '' }] as const;
    case 'productType':
      return [
        'LookingForMoreCategory',
        {
          category:
            product_type_name === 'Other'
              ? group_name?.toLowerCase() || ''
              : product_type_name?.toLowerCase() || '',
        },
      ] as const;
    case 'colour':
      return ['ShopByColour'] as const;
    default:
      return ['YouMightAlsoLike'] as const;
  }
}
